export default __webpack_public_path__ + "static/media/Flag_of_Fiji.7247dde2.svg";